const styles = (theme) => ({
  button: {
    float: 'right',
    marginBottom: theme.spacing(2),
  },
});

export default styles;
